import { useState } from "react";
import { fetchVideos } from "../../features/videos/videosSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Pagination() {
  const [num, setnum] = useState(1);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const { tags, search } = state.filter;
  const page = async (no) => {
    dispatch(fetchVideos({ tags, search, no }));
    setnum(no);
    console.log(no);
  };
  if (num === 1) {
  }
  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        <div
          className={`bg-blue-100 text-white px-4 py-1 rounded-full ${
            num === 1 && "bg-green-600"
          }`}
          onClick={() => page(1)}
        >
          1
        </div>
        <div
          className={`bg-blue-100  text-white px-4 py-1 rounded-full ${
            num === 2 && " bg-green-600"
          }`}
          onClick={() => page(2)}
        >
          2
        </div>
      </div>
    </section>
  );
}
